import React from "react";
import { TileLayer, TileLayerProps } from "react-leaflet";
import { getZoomLevels } from "../utils/tileset.helpers";
import L from "leaflet";
import { IMapresource } from "../models/Mapresource";

//@ts-ignore
L.RasterCoords = require('leaflet-rastercoords')

interface RasterLayerProps extends TileLayerProps {
    mapresource: IMapresource;
};

export const RasterLayer: React.FC<RasterLayerProps> = ({ mapresource, ...layerProps }) => {

    const { tileSet } = mapresource

    const { minZoom, maxZoom } = getZoomLevels(tileSet);

    return (
        <TileLayer
            minZoom={minZoom}
            maxZoom={maxZoom}
            {...layerProps}
            noWrap
        />
    );
};